export enum INDUSTRY_ENUM {
  MOBILE = 'MOBILE',
  RETAIL = 'RETAIL',
  RESTAURANT = 'RESTAURANT',
  PHARMACY = 'PHARMACY',
}
